<script>
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  props: {
      link: {
          type: String,
          default: ""
      },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: ""
    }
  }
};
</script>

<template>
  <router-link class="card mini-stats-wid" :to="link">
    <div class="card-body">
      <div class="media">
        <div class="media-body">
          <p class="text-muted font-weight-medium">{{title}}</p>
          <h4 class="mb-0">{{value}}</h4>
        </div>

        <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
          <span class="avatar-title">
            <i :class="`${icon} font-size-24`"></i>
          </span>
        </div>
      </div>
    </div>
    <!-- end card-body -->
  </router-link>
  <!-- end card -->
</template>
